import { render, staticRenderFns } from "./DefaultPage.vue?vue&type=template&id=26f25f7e&scoped=true"
import script from "./DefaultPage.vue?vue&type=script&lang=js"
export * from "./DefaultPage.vue?vue&type=script&lang=js"
import style0 from "./DefaultPage.vue?vue&type=style&index=0&id=26f25f7e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f25f7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26f25f7e')) {
      api.createRecord('26f25f7e', component.options)
    } else {
      api.reload('26f25f7e', component.options)
    }
    module.hot.accept("./DefaultPage.vue?vue&type=template&id=26f25f7e&scoped=true", function () {
      api.rerender('26f25f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Default-Page-Components/modules/DefaultPage.vue"
export default component.exports